import { defineComponent as _defineComponent } from 'vue'
import LPFooter from '@/views/layouts/lpLayout/LPFooter.vue';
import LPHeader from '@/views/layouts/lpLayout/lpHeader/LPHeader.vue';
import { checkForNewRelease } from '@/utils/latestRelease';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LPLayout',
  setup(__props) {

onMounted(async () => {
  if (
    process.env.VUE_APP_ENV === 'production' ||
    process.env.VUE_APP_ENV === 'staging'
  ) {
    await checkForNewRelease();
  }
});

return { __sfc: true,LPFooter, LPHeader }
}

})